import React, {FC, useState} from 'react';
import {connect} from 'react-redux';

import {makeMapStateToProps, ResolveStateProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {ResolveDispatchProps} from '../../../../helpers/reduxHelpers';
import {
  getHasInvoicesPastDue,
  getIsBilledThroughOtherCompany,
} from '../../../../store/data/company/companySelectors';
import {
  getIsUserBillingContact,
  getIsUserGlobalAdmin,
} from '../../../../store/data/teammates/teammatesSelectors';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {InvoicesPastDueBanner} from './invoicesPastDueBanner';

/*
 * Props.
 */

type InvoicesPastDueBannerContainerStateProps = ResolveStateProps<typeof mapStateToProps>;
type InvoicesPastDueBannerContainerDispatchProps = ResolveDispatchProps<typeof mapDispatchToProps>;
type InvoicesPastDueBannerContainerComponentProps = InvoicesPastDueBannerContainerStateProps &
  InvoicesPastDueBannerContainerDispatchProps;

/*
 * Component.
 */

export const InvoicesPastDueBannerContainerComponent: FC<InvoicesPastDueBannerContainerComponentProps> = (
  props,
) => {
  const {
    isGlobalAdmin,
    isBillingContact,
    hasInvoicesPastDue,
    isBilledThroughOtherCompany,
    onOpenBillingClick,
  } = props;
  const [isDismissed, setIsDismissed] = useState(false);

  const shouldDisplayBanner =
    isGlobalAdmin && isBillingContact && hasInvoicesPastDue && !isDismissed && !isBilledThroughOtherCompany;

  if (!shouldDisplayBanner) {
    return null;
  }

  return (
    <InvoicesPastDueBanner onDismissClick={() => setIsDismissed(true)} onLinkClick={onOpenBillingClick} />
  );
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isGlobalAdmin: getIsUserGlobalAdmin,
  hasInvoicesPastDue: getHasInvoicesPastDue,
  isBilledThroughOtherCompany: getIsBilledThroughOtherCompany,
  isBillingContact: getIsUserBillingContact,
}));

const mapDispatchToProps = {
  onOpenBillingClick: () => navigateToLinkAction('/settings/billing'),
};

export const InvoicesPastDueBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InvoicesPastDueBannerContainerComponent);
